import { Pipe, PipeTransform } from '@angular/core';
import {TranslocoService} from '@ngneat/transloco';

@Pipe({
  name: 'notifyTime'
})
export class NotifyTimePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {
  }

  transform(time: string): string {
    if (time.includes('-0')) {
      return this.translocoService.translate('notify.aSecondAgo');
    }
    return `${time.replace('-', '')} ${this.translocoService.translate('notify.ago')}`;
  }
}
